module.exports = __webpack_public_path__ + "front/img/m1.afbdbc44.jpg";